
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minitools",
      function () {
        return require("private-next-pages/minitools/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minitools"])
      });
    }
  